import React from 'react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Copy, CheckCircle2 } from 'lucide-react';

export default function TwoFASetupStep({ qrData, otp, setOtp, copied, onCopySecret, onVerify, processing }) {
  return (
    <div className="space-y-4 mt-4">
      <p className="text-sm text-muted-foreground">
        Scan this QR code with an authenticator app like Google Authenticator, Authy, or 1Password.
      </p>
      <div className="flex justify-center p-4 bg-white rounded-lg">
        <img src={qrData.qr_code_data_url} alt="2FA QR Code" className="w-56 h-56" data-testid="2fa-qr-code" />
      </div>
      <div>
        <Label className="text-xs uppercase tracking-wider text-muted-foreground">Or enter this key manually</Label>
        <div className="mt-1 flex items-center gap-2">
          <code className="flex-1 p-3 bg-muted rounded text-sm font-mono break-all" data-testid="2fa-secret">{qrData.secret}</code>
          <Button data-testid="copy-secret-btn" onClick={onCopySecret} variant="outline" size="icon" className="rounded-full shrink-0">
            {copied ? <CheckCircle2 className="w-4 h-4 text-green-600" /> : <Copy className="w-4 h-4" />}
          </Button>
        </div>
      </div>
      <div>
        <Label htmlFor="otp">Enter the 6-digit code from your app</Label>
        <Input
          id="otp"
          data-testid="2fa-verify-input"
          value={otp}
          onChange={(e) => setOtp(e.target.value.replace(/\D/g, '').slice(0, 6))}
          placeholder="123456"
          className="mt-2 text-center text-2xl tracking-widest font-mono"
          maxLength={6}
        />
      </div>
      <Button
        data-testid="2fa-verify-btn"
        onClick={onVerify}
        disabled={processing || otp.length !== 6}
        className="w-full rounded-full bg-primary hover:bg-primary/90 text-primary-foreground"
      >
        Verify & Enable
      </Button>
    </div>
  );
}
